import * as Branding from '@mgmresorts/client-utils/Branding';
const DEFAULT_MGM_SLUG = 'mgmresorts';
const propertySymbols = Object.getOwnPropertySymbols(Branding.Property.Config);
export const propertySlugs = propertySymbols.map(symbol => {
    const slug = Branding.slugOf(symbol);
    if (slug === 'www')
        return DEFAULT_MGM_SLUG;
    return slug;
});
export const propertyConfigs = Object.assign(Branding.Property.Config, {
    [Branding.Property.Mgm]: { ...Branding.Property.Config[Branding.Property.Mgm], slug: DEFAULT_MGM_SLUG },
});
export const getPropertyIdByPropertySlug = (slug) => {
    const propertySymbol = propertySymbols.find(symbol => {
        const propertySlug = Branding.slugOf(symbol);
        if (propertySlug === 'www') {
            return DEFAULT_MGM_SLUG === slug;
        }
        return propertySlug === slug;
    });
    if (!propertySymbol) {
        throw new Error(`Property slug "${slug}" not found`);
    }
    return Branding.idOf(propertySymbol);
};
export const getPropertyKeyByPropertySlug = (slug) => {
    const propertySymbol = propertySymbols.find(symbol => {
        const propertySlug = Branding.slugOf(symbol);
        if (propertySlug === 'www') {
            return DEFAULT_MGM_SLUG === slug;
        }
        return propertySlug === slug;
    });
    if (!propertySymbol) {
        throw new Error(`Property slug "${slug}" not found`);
    }
    return propertySymbol;
};
/**
 * Get the property config by the property id
 * @param propertyId - The property id
 * @returns The first matching property config
 */
export function getPropertyConfigById(propertyId) {
    const propertyKey = Object.getOwnPropertySymbols(Branding.Property.Config).find(key => Branding.Property.Config[key].id === propertyId);
    return propertyKey ? Branding.Property.Config[propertyKey] : undefined;
}
export function getPropertyConfigBySlug(propertySlug) {
    const propertyKey = getPropertyKeyByPropertySlug(propertySlug);
    return Branding.Property.Config[propertyKey];
}
export function getRegionIdByResortId(resortId) {
    return getPropertyConfigById(resortId)?.regionId;
}
export function getRegionIdByPropertySlug(propertySlug) {
    const propertyKey = getPropertyKeyByPropertySlug(propertySlug);
    return Branding.Property.Config[propertyKey].regionId;
}
export function getPropertyTickerByPropertySlug(propertySlug) {
    const propertyKey = getPropertyKeyByPropertySlug(propertySlug);
    return Branding.Property.Config[propertyKey].ticker;
}
export function getPropertyNameByResortId(resortId) {
    return getPropertyConfigById(resortId)?.websiteTitle;
}
export function getPropertyNameByPropertySlug(propertySlug) {
    const propertyKey = getPropertyKeyByPropertySlug(propertySlug);
    return Branding.Property.Config[propertyKey].websiteTitle;
}
